class FloatingMiniCart extends HTMLElement {
  connectedCallback() {
    this.link = this.querySelector('.floating-mini-cart__link');
    this.badge = this.querySelector('.floating-mini-cart__badge');

    if (this.dataset.cartType === 'drawer') {
      this.link.addEventListener('click', (event) => {
        const drawer = document.querySelector('cart-drawer');
        if (drawer) {
          event.preventDefault();
          drawer.open(this.link);
        }
      });
    }

    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      this.updateFromCart();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
  }

  updateFromCart() {
    fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => {
        if (this.badge) {
          this.badge.textContent = cart.item_count;
          this.badge.classList.toggle('hidden', cart.item_count === 0);
        }
      })
      .catch(() => {});
  }
}

customElements.define('floating-mini-cart', FloatingMiniCart);
